import { GeneralHelper } from 'src/app/helpers/general-helper';
import Asset from 'src/app/model/asset';
import Address from 'src/app/model/project/address';
import { Project } from 'src/app/model/project/project';
import { User } from 'src/app/model/user';
import { ImmoMapAppointmentInfo } from './immo-map-appointment-info';

export interface ImmoMapItem {
  id?: number;

  type?: string;

  currentCreatedAt?: Date;

  currentRequestDate?: Date;

  currentRequestASAP?: boolean;

  address?: Address;

  placementFloor?: string;

  assets?: Asset[];
  placerId?: number;
  tourDate?: Date;

  // display only
  popupDisplay?: string;

  typeDisplay?: string;

  typeClass?: string;

  firstAssetStyle?: any;

  appointmentInfoDisplay?: string;
}

export interface ImmoMapSubProject extends ImmoMapItem {
  project?: Project;
  appointmentInfo?: ImmoMapAppointmentInfo;
  adjustmentInfo?: string;
}

export interface ImmoMapImmoTask extends ImmoMapItem {
  subject?: string;
  requestingUser?: User;
}

export function isImmoMapSubProject(
  item: ImmoMapItem
): item is ImmoMapSubProject {
  return GeneralHelper.hasOwnProperty(item, 'project');
}

export function isImmoMapImmoTask(item: ImmoMapItem): item is ImmoMapImmoTask {
  return (
    GeneralHelper.hasOwnProperty(item, 'subject') ||
    GeneralHelper.hasOwnProperty(item, 'requestingUser')
  );
}
